module.exports = __webpack_public_path__ + "static/media/clover-icon.64e2bd13.png";